import useComputed from '@/hooks/use-computed/index';
import OrgAPI from '@/services/api/org';
import api from '@/services/api/userManagement.js';
import groupApi from "@/services/api/organizationGroup";
import { immerable } from "immer";
import { useState } from 'react';
import { useBuildex } from '@/hooks/use-buildex';
import { useFeature } from '@/hooks/use-feature';
import { featureConstant } from '@/constants/configuration/feature';

class UserManagement {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.email = params.Email
		this.image = params.IconUrl
		this.role = params.Role
		this.makerCheckerRole = params.MakerCheckerRole
		this.createdAt = params.CreatedAt
		this.userGroupIds = params.UserGroupIds
		this.$selected = false
	}
}

const useUserManagement = () => {
	const isBuildex = useBuildex();
	const isUserAccessManagementPhase2Enabled = useFeature(featureConstant.USER_ACCESS_MANAGEMENT_PHASE_2);

	const [itemsUserManagement, setItemsUserManagement] = useComputed([])
	const [metaUserManagement, setMetaUserManagement] = useState(null)
	const [loadingUserManagement, setLoadingUserManagement] = useState(false)
	const [errorUserManagement, setErrorUserManagement] = useState()

	async function fetchUserManagement(payload) {
		setLoadingUserManagement(true)

		const params = payload ? payload : "";

		const [error, response] = await api.index({ params })

		setLoadingUserManagement(false)

		if (error) {
			return setErrorUserManagement(error)
		}

		const { items, meta } = response

		if (!Array.isArray(items)) {
			return setErrorUserManagement('User Management is not an array')
		}

		const serializedData = items.map(entry => serialize(entry))
		const newItems = serializedData.map(parameter => new UserManagement(parameter))

		setMetaUserManagement(meta)
		setItemsUserManagement(newItems)
	}

	async function hasAtLeastOneMakerCheckerRole(orgId, changedValues) {
		const [error, response] = await api.hasAtLeastOneMakerCheckerRole(orgId, changedValues)

		if (error) {
			// return setErrorUserManagement('User Management API has error')
			return { 'MAKER': 0, 'CHECKER': 0 }
		}

		return response
	}

	async function getPendingMakerCheckerTransactions(orgId) {
		const [error, response] = await OrgAPI.getPendingMakerCheckerTransactions(orgId)

		if (error) {
			return setErrorUserManagement(error)
		}

		return response
	}

	async function assignSelectedUsersToGroups(selectedUserIds, selectedGroups, users, addToastMessage, toastType, organizationId) {
		try {
			const newGroupIds = selectedGroups.map(group => group.id);

			const payload = selectedUserIds.map(userId => {
				const user = users.find(user => user.id === userId);
				const currentGroupIds = user?.userGroupIds || [];
				const combinedGroupIds = [...new Set([...currentGroupIds, ...newGroupIds])];
				
				return {
					userId: userId,
					groupIds: combinedGroupIds
				};
			});
			
			const [error] = await groupApi.assignUser(payload, organizationId);
			
			if (error) {
				addToastMessage("Failed to assign users to groups.", toastType.error);
				return { success: false };
			}

			addToastMessage("Users successfully assigned to groups.", toastType.success);
			return { success: true };
			
		} catch (error) {
			console.error('Error assigning users to groups:', error);
			addToastMessage("An error occurred while assigning users to groups.", toastType.error);
			return { success: false };
		}
	}

	function serialize(entry) {
		return {
			id: entry.id,
			Email: entry.email,
			IconUrl: entry.IconUrl,
			Role: entry.role,
			MakerCheckerRole: entry.makerCheckerRole,
			CreatedAt: entry.created,
			...((isBuildex && isUserAccessManagementPhase2Enabled) ? { UserGroupIds: entry.userGroups?.map(g => g.groupId) } : {}),
		}
	}

	return {
		assignSelectedUsersToGroups,
		errorUserManagement,
		fetchUserManagement,
		hasAtLeastOneMakerCheckerRole,
		getPendingMakerCheckerTransactions,
		itemsUserManagement,
		loadingUserManagement,
		metaUserManagement
	}

}

export default useUserManagement;